'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionChecklist', ['$scope', '$stateParams', 'IPChecklists', 'FBResponses', '$q', 'IPInspections', '$window', '$timeout', 'Session',
        function ($scope, $stateParams, IPChecklists, FBResponses, $q, IPInspections, $window, $timeout, Session) {
            // Initialize scope variables
            $scope.resetInspection();
            $scope.checklist = $stateParams.checklist;
            $scope.masterChecklist = $stateParams.checklist;
            $scope.checklistID = $stateParams.checklistID;
            $scope.deficiencyScore = { score: 0 };
            $scope.deficiencies = {
                fail: 0,
                pass: 0,
                ignore: 0
            }
            $scope.saving = false;
            $scope.submitting = false;
            $scope.checklistForm = {};
            $scope.loadingMessage = '';
            $scope.failSubmit = false;
            $scope.failSubmitMessage = '';
            $scope.validationMessage = null;
            $scope.validationSuccess = false;

            $scope.getChecklist = function () {
                $scope.loading = true;

                IPChecklists.getByID($stateParams.checklistID).then(function (checklist) {
                    var promises = [];

                    // Load existing response or create new one
                    if (checklist.response_id != null) {
                        promises.push(FBResponses.getByID(checklist.response_id).then(function (response) {
                            checklist.response = response;
                        }))
                    }
                    else if (checklist.template != null) {
                        promises.push(FBResponses.save({ Form_ID: checklist.template.form_id }, checklist.id).then(function (response) {
                            checklist.response_id = response.id;
                            checklist.response = response;
                        }))
                    }

                    $q.all(promises).then(function () {
                        // Initialize deficiency counts
                        $scope.deficiencies.fail = checklist.deficiencies_fail != null ? checklist.deficiencies_fail : 0;
                        $scope.deficiencies.pass = checklist.deficiencies_pass != null ? checklist.deficiencies_pass : 0;
                        $scope.deficiencies.ignore = checklist.deficiencies_ignore != null ? checklist.deficiencies_ignore : 0;

                        $scope.checklist = checklist;

                        // Default to in-person signature if signoff is required
                        if ($scope.checklist.template.require_responsible_party_signoff === true && ($scope.checklist.signature_type_in_person === null || $scope.checklist.signature_type_in_person === undefined)) {
                            $scope.checklist.signature_type_in_person = true;
                        }

                        $scope.passingChecklist = $scope.checklist.template;
                        $scope.passingChecklist.inspectionID = $scope.$parent.inspectionID;
                        $scope.masterChecklist = angular.copy($scope.checklist);
                        $scope.loading = false;
                    }).catch(function (response) {
                        // handle error
                    });
                });
            }

            // Clear signature fields when switching to virtual signature
            $scope.clearSignature = function () {
                if ($scope.checklist.signature_type_in_person == false && $scope.checklist.checklist_signed != true) {
                    $scope.checklist.signature_first_name = null;
                    $scope.checklist.signature_last_name = null;
                    $scope.checklist.signature_certification_number = null;
                    $scope.checklist.signature_photo_source = null;
                    $scope.checklistForm.signature = null;
                }
            }

            // Check if signature is required based on template settings
            $scope.isSignatureRequired = function () {
                return $scope.checklist &&
                    $scope.checklist.template &&
                    $scope.checklist.template.require_responsible_party_signature &&
                    $scope.checklist.signature_type_in_person === true;
            };

            // Check if the signature pad is empty
            $scope.isSignatureEmpty = function () {
                // Check if signature pad exists and has the _isEmpty flag set to false
                if ($scope.checklistForm && $scope.checklistForm.signature && $scope.checklistForm.signature._isEmpty === false) {
                    return false; // Has signature data
                }

                // Check if signature photo source exists and has data
                if ($scope.checklist && $scope.checklist.signature_photo_source) {
                    return false; // Has signature data
                }

                return true; // No signature data found
            };

            // Validate form including signature if required
            $scope.isFormValid = function (the_form) {
                var valid = the_form.$valid;

                if (valid && $scope.isSignatureRequired()) {
                    if ($scope.isSignatureEmpty()) {
                        valid = false;
                    }
                }

                return valid;
            };

            // Clear the signature pad canvas
            $scope.clearSignaturePad = function () {
                if ($scope.checklistForm && $scope.checklistForm.signature) {
                    // Clear the signature pad
                    $scope.checklistForm.signature.clear();

                    // Set the _isEmpty flag
                    $scope.checklistForm.signature._isEmpty = true;

                    // Clear the model
                    $scope.checklist.signature_photo_source = null;

                    // Set validation error if signature is required
                    if ($scope.isSignatureRequired() && $scope.the_form && $scope.the_form.signatureField) {
                        $scope.the_form.signatureField.$setValidity('required', false);
                        $scope.the_form.signatureField.$setTouched();
                    }
                }
            };

            // Hook into signature pad to clear validation when user draws
            var unwatchCanvas = $scope.$watch(function () {
                return document.querySelector('.sig.sigWrapper canvas');
            }, function (canvas) {
                if (canvas) {
                    unwatchCanvas();

                    $timeout(function () {
                        var canvasElement = angular.element(canvas);
                        // Access the isolated scope created by ng-signature-pad directive
                        var isolatedScope = canvasElement.isolateScope() || canvasElement.scope();

                        if (isolatedScope && isolatedScope.ngSignaturePad) {
                            var signaturePad = isolatedScope.ngSignaturePad;

                            // Store reference in checklistForm for easy access
                            $scope.checklistForm.signature = signaturePad;

                            var originalOnEnd = signaturePad.onEnd;

                            // Override onEnd to update model and clear validation after each stroke
                            signaturePad.onEnd = function () {
                                if (originalOnEnd && typeof originalOnEnd === 'function') {
                                    originalOnEnd.call(this);
                                }

                                $scope.$applyAsync(function () {
                                    if (!signaturePad.isEmpty()) {
                                        // Set _isEmpty flag to false when signature is drawn
                                        signaturePad._isEmpty = false;

                                        // Update the signature photo source
                                        $scope.checklist.signature_photo_source = signaturePad.toDataURL();

                                        // Clear validation error when signature is drawn
                                        if ($scope.the_form && $scope.the_form.signatureField) {
                                            $scope.the_form.signatureField.$setValidity('required', true);
                                            $scope.the_form.signatureField.$setTouched();
                                        }
                                    }
                                });
                            };
                        }
                    }, 100);
                }
            });

            // Watch for reinspection checkbox changes
            $scope.$watch('inspection.reinspect', function () {
                if ($scope.inspection.reinspect) {
                    // Set reinspection date based on template settings
                    $scope.inspection.reinspection_date = new Date();
                    $scope.inspection.reinspection_date.setHours(0, 0, 0, 0);
                    if ($scope.checklist.template.reinspection != null) {
                        $scope.inspection.reinspection_date.setDate($scope.inspection.reinspection_date.getDate() + $scope.checklist.template.reinspection);
                    }
                }
            })

            // Load checklist on controller initialization
            if ($stateParams.checklistID != null) {
                $scope.getChecklist();
            }

            // Check if all deficiency items are completed
            $scope.complete = function () {
                return $scope.deficiencies.fail + $scope.deficiencies.pass + $scope.deficiencies.ignore == $scope.checklist.template.deficiencies_total;
            }

            // Determine if inspection failed based on deficiencies or score
            $scope.failed = function () {
                if ($scope.checklist.template.passing_score_type) {
                    return $scope.checklist.template.passing_score > $scope.deficiencyScore.score;
                }
                else {
                    return $scope.deficiencies.fail >= $scope.checklist.template.auto_fail;
                }
            }

            // Save checklist without submitting (no PDF generation)
            $scope.save = function (checklist, the_form) {
                Session.checkIn();

                $scope.validationMessage = null;
                $scope.validationSuccess = false;
                the_form.validationMessages = null;

                var formValid = the_form.$valid;

                $scope.saving = true;
                $scope.saveChecklist(checklist);
                $scope.inspection.reinspect = false;
                $scope.inspection.checklist = checklist;

                $scope.failSubmit = false;

                // Clear signature if empty
                if ($scope.isSignatureEmpty()) {
                    $scope.inspection.checklist.signature_photo_source = null;
                    $scope.inspection.checklist.checklist_signed = false;
                }

                $scope.loadingMessage = "Saving Checklist...";
                IPInspections.saveIPChecklist($scope.inspection.checklist, $scope.inspection.id).then(function (savedChecklist) {
                    if (savedChecklist != null) {
                        IPInspections.save($scope.inspection, false, false).then(function (savedInspection) {
                            savedChecklist = null;
                            savedInspection = null;
                            $scope.saving = false;
                            $scope.failSubmit = false;

                            // Show validation message
                            if (formValid) {
                                $scope.validationMessage = "All required information has been supplied";
                                $scope.validationSuccess = true;
                            }
                            else {
                                $scope.validationMessage = "Checklist saved, but required information is missing";
                                $scope.validationSuccess = false;
                            }
                            $window.scrollTo(0, 0);

                            // Clear validation message after 3 seconds
                            var validationTimeout = $timeout(function () {
                                $scope.validationMessage = null;
                                $scope.validationSuccess = false;
                            }, 3000);

                            $scope.$on('$destroy', function () {
                                $timeout.cancel(validationTimeout);
                            });
                        });
                    }
                    else {
                        $scope.saving = false;
                        $scope.failSubmit = true;
                        $scope.failSubmitMessage = "Save of inspection failed, and the form data was not saved. Please try saving the inspection again.";
                    }

                    // Reload checklist and inspection data
                    $scope.deficiencyScore.score = 0;
                    $scope.getChecklist();
                    $scope.getInspection();
                });
            }

            // Submit checklist (generates PDF and fires triggers)
            $scope.submit = function (checklist) {
                Session.checkIn();

                $scope.validationMessage = null;
                $scope.validationSuccess = false;

                var d = $q.defer();

                var promises = [];
                $scope.submitting = true;
                $scope.failSubmit = false;

                // Validate signature if required
                if ($scope.isSignatureRequired() && $scope.isSignatureEmpty()) {
                    if ($scope.the_form && $scope.the_form.signatureField) {
                        $scope.the_form.signatureField.$setValidity('required', false);
                        $scope.the_form.signatureField.$setTouched();
                    }
                    $scope.submitting = false;
                    return;
                }

                $scope.loadingMessage = "Saving Checklist...";

                // Clear signature fields if virtual signature selected
                if (checklist.signature_type_in_person === false) {
                    checklist.signature_first_name = null;
                    checklist.signature_last_name = null;
                    checklist.signature_certification_number = null;
                    checklist.signature_photo_source = null;
                    checklist.checklist_signed = false;
                }
                // Mark as signed if in-person signature required
                else if (checklist.template.require_responsible_party_signoff === true
                    && (checklist.template.virtual_signature === false || checklist.signature_type_in_person === true)) {
                    checklist.checklist_signed = true;
                }

                $scope.saveChecklist(checklist);
                if (!$scope.complete() || !$scope.failed()) {
                    $scope.inspection.reinspect = false;
                }
                $scope.inspection.checklist = checklist;

                IPInspections.saveIPChecklist($scope.inspection.checklist, $scope.inspection.id).then(function (savedChecklist) {
                    if (savedChecklist != null) {
                        promises.push(IPInspections.save($scope.inspection, true, false));

                        // Gather data and generate PDF
                        $scope.loadingMessage = "Gathering data for pdf generation...";
                        promises.push(IPChecklists.getDocumentsAndComments($scope.inspection)
                            .then(function (inspection) {
                                if (inspection != null) {
                                    $scope.loadingMessage = "Generating PDF...";
                                    IPChecklists.generatingPDF($scope.inspection)
                                        .then(function (successGeneratePDF) {
                                            if (successGeneratePDF) {
                                                $scope.failSubmit = false;
                                                d.resolve(true);
                                            }
                                            else {
                                                $scope.failSubmit = true;
                                                $scope.failSubmitMessage = "Inspection PDF failed to generate. Form data successfully saved and PDF can be regenerated at another time by resubmitting the form.";
                                                d.resolve(false);
                                            }
                                            $scope.deficiencyScore.score = 0;
                                            $scope.getChecklist();
                                            $scope.getInspection();
                                        });
                                }
                                else {
                                    $scope.failSubmit = true;
                                    $scope.failSubmitMessage = "Gathering data for pdf generation failed. Form data successfully saved and PDF can be regenerated at another time by resubmitting the form.";
                                    d.resolve(false);
                                }
                            })
                        );

                        $q.all(promises).then(function (arr) {
                            $scope.submitting = false;
                        }).catch(function (response) {
                            // handle error
                        });
                    }
                    else {
                        $scope.submitting = false;
                        $scope.failSubmit = true;
                        $scope.failSubmitMessage = "Submission of inspection failed, and the form data was not saved. Please try submitting the inspection again.";
                        d.resolve(false);
                    }
                });
            }

            // Save checklist data to inspection object
            $scope.saveChecklist = function (checklist) {
                // Convert signature pad to data URL if available
                if ($scope.checklistForm.signature != null && !$scope.checklistForm.signature.isEmpty()) {
                    checklist.signature_photo_source = $scope.checklistForm.signature.toDataURL();
                }

                // Update deficiency counts
                checklist.deficiencies_fail = $scope.deficiencies.fail;
                checklist.deficiencies_pass = $scope.deficiencies.pass;
                checklist.deficiencies_ignore = $scope.deficiencies.ignore;

                // Set inspection outcome if complete
                if ($scope.complete()) {
                    $scope.inspection.outcome = !$scope.failed();
                }
                else {
                    $scope.inspection.outcome = null;
                }
            }

            // Resize canvas for high DPI displays
            $scope.resize = function () {
                if (document != null && document.querySelector != null) {
                    var canvas = document.querySelector("canvas");

                    if (canvas != null && canvas.offsetWidth != null && canvas.offsetHeight != null && canvas.getContext != null) {
                        var ratio = Math.max(window.devicePixelRatio || 1, 1);
                        canvas.width = canvas.offsetWidth * ratio;
                        canvas.height = canvas.offsetHeight * ratio;
                        canvas.getContext("2d").scale(ratio, ratio);
                    }
                }
            }
        }])
    ;